import { Skeleton } from "@bowfast/ui/components/skeleton";

const STAT_KEYS = ["stat-a", "stat-b", "stat-c", "stat-d"] as const;

interface DetailPageSkeletonProps {
  /** Number of stat tiles to render (max 4). Defaults to 4. */
  statCount?: 1 | 2 | 3 | 4;
}

export function DetailPageSkeleton({ statCount = 4 }: Readonly<DetailPageSkeletonProps>) {
  return (
    <div className="mx-auto w-full max-w-350 space-y-6 p-4 md:p-6">
      <Skeleton className="h-8 w-28" />
      <Skeleton className="h-36 w-full rounded-xl" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {STAT_KEYS.slice(0, statCount).map((key) => (
          <Skeleton key={key} className="h-24 rounded-xl" />
        ))}
      </div>
      <Skeleton className="h-64 w-full rounded-xl" />
    </div>
  );
}
